<div class="flex flex-col py-8 justify-center items-center" style="overflow: hidden;">
  <div class="container-padding max-w-screen-desktop mx-auto w-full">
    <div class="flex justify-center items-center">
      <div class="py-6 px-6 shadow rounded-2xl sm:px-10 my-4 border border-4 border-[var(--black)] bg-[var(--white)] w-full max-w-[600px]">
        <h2 class="uppercase text-[42px]/[65px] font-normal text-[var(--dark-orange)]">
          {{ 'resetPassword.title' | translate }}
        </h2>
        <div class="w-full border-t border-dotted mb-6 mt-2"></div>

        <!-- Estado de éxito: solo mensaje + botón ir al login -->
        <div *ngIf="isSuccess" class="flex flex-col items-center gap-6 py-4">
          <svg width="56" height="56" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="12" fill="#22c55e" opacity="0.12"/>
            <path d="M7 12.5L10.5 16L17 9" stroke="#22c55e" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <p class="font-bold text-[16px] text-center" style="color: green;">
            {{ successMessage }}
          </p>
          <a routerLink="/login">
            <app-button [text]="'resetPassword.login' | translate" [fullWidth]="true"></app-button>
          </a>
        </div>

        <!-- Formulario: solo visible si no hubo éxito -->
        <form *ngIf="!isSuccess" [formGroup]="resetPasswordForm" (submit)="onSubmit()" class="">
          <div class="flex flex-col gap-6">
            <app-input [control]="resetPasswordForm.controls['newPassword']" inputId="new-password" type="password"
              autocomplete="new-password" placeholder="******" [label]="'resetPassword.newPassword' | translate"></app-input>

            <app-input [control]="resetPasswordForm.controls['confirmPassword']" inputId="confirm-password" type="password"
              placeholder="******" autocomplete="new-password" [label]="'resetPassword.confirmPassword' | translate"></app-input>
          </div>

          <div class="mt-8">
            <app-button [submit]="true" [disabled]="isLoading" [text]="isLoading ? ('resetPassword.loading' | translate) : ('resetPassword.submit' | translate)" [fullWidth]="true"></app-button>
          </div>

          <div *ngIf="errorMessage" class="mt-6 font-bold text-[14px]/[14px] text-center" style="color: red;">
            {{ errorMessage }}
          </div>

          <div class="mt-12 flex justify-center p-3">
            <a routerLink="/login" class="uppercase font-bold text-[var(--black)] text-[14px]/[14px]">
              {{ 'resetPassword.login' | translate }}
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
